import PageContent from "./pages/all"

const images = require.context("./images", true)
const audios = require.context("./audios", true)

const content = {
	name: "रमाइलो मेला",
	key: "ramailo-mela",
	coverImage: images("./cover-page2.png"),

	// Credits section to add information for credit page
	credits: {
		writer: "साझा शिक्षा ई-पाटी", // Name of the writer | optional
		illustrator: "निजा महर्जन", // Name of the illustrator | optional
		template: "default", // template to be used: write one of 'ratoBangla' or 'default' | required
		bg: images("./page10.jpg"), // background image for credit page and end modal page | required
		titleAudio: audios("./page1.ogg"), // audio for title vocal, can be usually found on page one, can be copied from there | required
	},
	bgColor: "white", // used to add a bg color to ending pages, writing 'white' adds the class 'bg-white' to credit and end pages | optional
	content: PageContent,
}

export default content
